<template>
    <div class="global_sidebar">
        <div class="hedaer">
            <div class="top_header">
                <span class="back_page" @click="backPage()" style="display: flex;align-items: center;"><fa icon="arrow-left"/>Voltar</span>
                <span @click="storeShowSidebar({showSidebar:!this.showSidebar});" style="display: flex;align-items: center;" v-show="largura<768"><fa icon="fa-xmark"/></span>
            </div>
            <div class="info-course">
                <span>{{this.currentCoursePortal.course.comercialName}}</span>
                <div class="progress_item">
                    <div class="progress-container">
                        <div class="progress-bar" :style="{ width: (this.porcetageProgressCurrentCourse ? this.porcetageProgressCurrentCourse : 0)+ '%' }">
                        </div>
                    </div>
                    {{formatNumber(this.porcetageProgressCurrentCourse ? this.porcetageProgressCurrentCourse : 0)}}%
                </div>
            </div>
        </div>
        <div class="modules">
            <v-expansion-panels variant="accordion" v-model="currentModuleOpenLocal">
                <v-expansion-panel v-for="(item, index) in data" :key="index">
                  <v-expansion-panel-title expand-icon="mdi-menu-down" >
                    <div class="title_accordion">
                      <span>{{item.title}}</span>
                      <span class="count">{{item.lessonQtyRead? item.lessonQtyRead : 0}} / {{item.lessons.length}}</span>
                    </div>
                  </v-expansion-panel-title>
            
                  <v-expansion-panel-text class="content" :class="{'active' : lesson.id == idLessonPortal}" v-for="(lesson, i) in item.lessons" :key="i">
                    <div class="lesson" @click="setCurrentLesson(lesson.id, i, lesson.type, index, lesson.title, lesson)">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" 
                        v-if="isLessonConcluida(lesson)" 
                        style="width: 25px; height: 25px; fill: #84ba41;">
                        <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"/>
                      </svg>
            
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" 
                          v-else 
                          style="width: 25px; height: 25px; fill: #91a8d0;">
                            <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"/>
                        </svg>
                      <span>{{lesson.title}}</span>
                    </div>
                  </v-expansion-panel-text>
        
                </v-expansion-panel>
              </v-expansion-panels>
        </div>

    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default{
    data(){
        return{
            activePanel:0,
            currentIndex:0,
            nameCourse: 'Curso de Teste',
            currentModuleOpenLocal: this.currentModuleOpen? this.currentModuleOpen : 0,
            largura:window.innerWidth,
            progress:0,
            // Variável para guardar os IDs das aulas abertas (vistas)
            openedLessons: [],
        }
    },
    computed:{
        ...mapState(['token','currentLesson','currentModuleOpen','idLessonPortal','nameCurrentLesson','currentCoursePortal','porcetageProgressCurrentCourse']),
        ...mapState(['typeLessonPortal']),
        ...mapState(['showSidebar']),
    },
    watch: {
        porcetageProgressCurrentCourse(newValue) {
            this.porcetageProgressCurrentCourseLocal = newValue;
        },
        activeModule(newValue) {
            this.activePanel = this.activeModule;
        },
    },
    props:{
        data:Array,
        currentLesson: String,
        activeModule:Number
    },
    methods:{
        ...mapActions(['storeTypeLessonPortal', 'storeIdLessonPortal','storeCurrentModuleOpen','storeCurrentLesson','storeNameCurrentLesson','storeShowSidebar']),
        ...mapActions(['storePorcetageProgressCurrentCourse']),

        setPorcetageProgressCurrentCourse(porcetageProgressCurrentCourse){
            if(porcetageProgressCurrentCourse != 0 && porcetageProgressCurrentCourse != null){
                this.storePorcetageProgressCurrentCourse({ porcetageProgressCurrentCourse: porcetageProgressCurrentCourse });
            }
        },
        
        setCurrentLesson(id, indexLesson, type, index, name, lesson){
            // Adiciona o id da aula aberta à lista de aulas vistas, se ainda não estiver lá
            if (!this.openedLessons.includes(id)) {
                this.openedLessons.push(id);
            }

            console.debug( id, indexLesson, type, index);

            this.storeIdLessonPortal({ idLessonPortal: id });
            this.storeCurrentLesson({currentLesson:indexLesson});
            this.storeTypeLessonPortal({ typeLessonPortal: type });
            this.storeCurrentModuleOpen({ currentModuleOpen: index });
            this.storeNameCurrentLesson({ nameCurrentLesson:name });
            this.storeCurrentLesson({currentLesson:lesson});
            const largura = window.innerWidth;
            if(largura < 768){
                this.storeShowSidebar({showSidebar:false});
            }

            // window.location.reload();

            // this.$emit('lessonChanged', id);
            // this.$emit('typeChanged', type);
            // this.$emit('updateLessonName',name)
            // this.currentIndex = index;
        },
        backPage() {
            this.$router.go(-1);
        }, 
        formatNumber(value) {
            if (typeof value === 'number') {
                return value.toFixed(0);
            } else {
                let parsed = parseFloat(value);
                return isNaN(parsed) ? 'Invalid Number' : parsed.toFixed(0);
            }
        },
        // Função para simular progress == 1 na lição atual OU se ela foi aberta (vista)
        isLessonConcluida(lesson) {
            // Se for a lição atual, sempre retorna true (simula progress == 1)
            if (lesson.id == this.idLessonPortal) {
                return true;
            }
            // Se a aula foi aberta (está na lista de abertas), também retorna true
            if (this.openedLessons.includes(lesson.id)) {
                return true;
            }
            // Caso contrário, retorna o valor real
            return lesson.progress == 1;
        },
    },
    created(){
        if(this.activeModule){
            this.activePanel = this.activeModule;
        } else {
            this.activePanel = 0;
        }
        this.setPorcetageProgressCurrentCourse(this.currentCoursePortal.progress);
    },
    watch: {
    activeModule(newValue, oldValue) {
        this.activePanel = this.activeModule;
    },
  }
}

</script>
<style>
.v-expansion-panel-text__wrapper {
    padding: 16px 10px!important;
    flex: 1 1 auto;
    max-width: 100%;
}
.global_content_course.dark .v-expansion-panel-text.content {
    background-color: #000000;
}
</style>
<style scoped>

.global_sidebar{
    background-color: white;
    height: 100%;
}
.top_header {
    cursor: pointer;
    padding: 20px 20px 10px;
    text-align: left;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: space-between;
}
.top_header i{
    font-size: 12px;
}
.progress-container {
    width: 85%;
    height: 8px;
    background-color: #f0f0f08f;
    margin-bottom: 20px;
    position: relative;
    border-radius: 10px;
    margin: 0 auto;
}
.progress-bar {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #84ba41;
    height: 8px;
    border-radius: 10px;
    margin: 0;
}
.info-course {
    text-align: left;
    padding: 20px;
    font-weight: 700;
}
.progress_item {
    display: flex;
    align-items: center;
    font-size: 12px;
    gap: 15px;
    font-weight: 500;
    margin-top: 5px;
}
i.pi.pi-check-circle {
    color: #84ba41;
    
}
.title_accordion {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.lesson{
    text-align: left;
    cursor: pointer;
    display: flex;
    gap: 10px;
    align-items: center;
}
span.count {
    font-size: 12px;
    color: gray;
}
.v-expansion-panel-title {
    background-color: #f1f1f1;
}
.v-expansion-panel-text.content:hover {
    background-color: #f2f2f2;
}
.dark .v-expansion-panel-title {
    background-color: #272727;
    color: white;
}
 button.v-expansion-panel-title.v-expansion-panel-title--active {
    background-color: #e3e3e3;
}
.global_content_course.dark button.v-expansion-panel-title.v-expansion-panel-title--active {
    background-color: #666666;
}
.v-expansion-panel-text.content {
    border-left: 5px solid transparent;
}

.v-expansion-panel-text.content.active {
    border-left: 5px solid #84ba41;
    background-color: #f2f2f2;
}
.global_content_course.dark .v-expansion-panel-text.content.active {
    border-left: 5px solid #84ba41;
    background-color: #2a2a2a;
}
.v-expansion-panel-title {
    padding: 24px 10px;
}
.modules {
    overflow-y: auto;
    height: 86vh;
}
.global_content_course.dark .lesson {
    color: white;
}
svg.svg-inline--fa.fa-arrow-left {
    margin-right: 10px;
}
.dark button.v-expansion-panel-title.v-expansion-panel-title--active span.count {
    color: white;
}
.global_content_course.dark .v-expansion-panel-text.content:hover {
    background-color: #2a2a2a;
}

span.back_page svg {
    transition: all 0.3s ease-in-out;
}
span.back_page:hover svg {
    animation: move 0.5s;
}

@keyframes move {
    0% { transform: translateX(0px); }
    50% { transform: translateX(10px); }
}
</style>